// components/TestSearch.jsx

import React from "react";

import { CiSearch } from "react-icons/ci";

import { useSearchStock } from "../../context/SearchStockContext";

const TestSearch = () => {
  const {
    searchStockQuery,
    setSearchStockQuery,

    searchResults,

    searchLoading,

    handleSelectSearchStock,
  } = useSearchStock();

  console.log("Search Results:", searchResults);

  return (
    <div
      style={{
        padding: "20px",
      }}
    >
      <h2>Search Test Component</h2>

      {/* SEARCH INPUT */}
      <div className="input-search">
        <input
          type="text"
          placeholder="Search Stocks..."
          value={searchStockQuery}
          onChange={(e) => setSearchStockQuery(e.target.value)}
        />

        <span>
          <CiSearch />
        </span>
      </div>

      {/* LOADING */}
      {searchLoading && (
        <p
          style={{
            marginTop: "10px",
          }}
        >
          Searching...
        </p>
      )}

      {/* RESULTS */}
      {searchResults.length > 0 && (
        <div className="search-dropdown">
          {searchResults.map((item) => (
            <div
              key={item.securityId}
              className="search-dropdown-item"
              onClick={() => {
                handleSelectSearchStock(item);

                console.log("Selected:", item);
              }}
            >
              <div className="dropdown-symbol">{item.symbol}</div>

              <div className="dropdown-company">{item.displayName}</div>
            </div>
          ))}
        </div>
      )}

      {/* NO RESULTS */}
      {!searchLoading &&
        searchStockQuery.length >= 2 &&
        searchResults.length === 0 && (
          <p
            style={{
              marginTop: "10px",
            }}
          >
            No stocks found
          </p>
        )}
    </div>
  );
};

export default TestSearch;
